export default __webpack_public_path__ + "static/designsprint-fe860fcfeaf2454b50001b85ef5c22cf.jpg";